// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__2Aigk","icon":"loader_icon__3swQZ","spin":"loader_spin__2ABl-"};